// this is used to check if url is relative: `/` or `/path` and not protocol-less `//anything`
// source: https://github.com/opendoor-labs/web/pull/41459/files
const VALID_RELATIVE_REDIRECT_REGEX = /^\/([^/]|$)/;

export function isValidRelativeRedirectTo(redirectTo: string) {
  const decodedRedirectTo = decodeURIComponent(redirectTo);
  return VALID_RELATIVE_REDIRECT_REGEX.test(decodedRedirectTo);
}
